<template>
    <div class="Summary">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <h4>Location <GoogleMapsLink v-bind:address="CareCommunityRecordData.Address" /></h4>
                    <div>
                        <p>
                            <span class="bold">Name: </span>
                            <StringEditor v-bind:old-value="CareCommunityRecordData.Name"
                                          v-bind:record-id="CareCommunityRecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Name"
                                          property-name="Name"
                                          update-method="Foster/CareCommunity/UpdateCareCommunity"
                                          v-bind:required="true" />
                        </p>
                        <p>
                            <span class="bold">Team Leader's Name: </span>
                            <StringEditor v-bind:old-value="CareCommunityRecordData.TeamLeaderName"
                                          v-bind:record-id="CareCommunityRecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Name"
                                          property-name="Name"
                                          update-method="Foster/CareCommunity/UpdateCareCommunity"
                                          v-bind:required="true" />
                        </p>
                        <p>
                            <span class="bold">Team Leader's Email: </span>
                            <StringEditor v-bind:old-value="CareCommunityRecordData.TeamLeaderEmail"
                                          v-bind:record-id="CareCommunityRecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Email"
                                          property-name="TeamLeaderEmail"
                                          update-method="Foster/CareCommunity/UpdateCareCommunity"
                                          v-bind:required="true" />
                        </p>
                        <p>
                            <span class="bold">Team Leader's Phone Number: </span>
                            <StringEditor v-bind:old-value="CareCommunityRecordData.TeamLeaderPhoneNumber.FormattedPhoneNumber"
                                          v-bind:record-id="CareCommunityRecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Phone Number"
                                          property-name="PhoneNumberDigits"
                                          update-method="Foster/CareCommunity/UpdateCareCommunity"
                                          v-bind:required="true" />
                        </p>
                        <p>
                            <AddressEditor v-bind:old-value="CareCommunityRecordData.Address"
                                           v-bind:record-id="CareCommunityRecordData.Address.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="Physical Address"
                                           update-method="Core/Address/Update"
                                           :chart-id="CareCommunityRecordData.Id"
                                           required="true" />
                        </p>
                        <p>
                            <span class="bold">Active: </span>
                            <SelectEditor v-bind:old-value="CareCommunityRecordData.IsActive"
                                          v-bind:old-value-text="CareCommunityRecordData.IsActive == true ? 'Yes' : 'No'"
                                          v-bind:record-id="CareCommunityRecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Active"
                                          property-name="IsActive"
                                          update-method="Foster/CareCommunity/UpdateCareCommunity"
                                          v-bind:options="TrueFalseOptions"
                                          :chart-id="CareCommunityRecordData.Id" />
                        </p>
                    </div>
                </div>
                <div class="col-md-4">
                    <h4>Families ({{ CurrentFamilyCount }})</h4>
                    <div v-for="client in CurrentFamilies">
                        <p>{{ client.Family.Name }}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <h4>Notes:</h4>
                    <TextAreaEditor v-bind:old-value="CareCommunityRecordData.Notes"
                                    v-bind:record-id="CareCommunityRecordData.Id"
                                    v-bind:edit-mode="EditMode"
                                    data-label="Notes"
                                    property-name="Notes"
                                    update-method="Foster/CareCommunity/UpdateCareCommunity"
                                    required="false"
                                    :global-update="true" />
                </div>
            </div>
        </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    import GoogleMapsLink from "../../../Core/LinkShortcuts/GoogleMapsLink.vue";
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    import StringEditor from '../../../Core/ItemEditors/StringEditor';
    import AddressEditor from '../../../Core/ItemEditors/AddressEditor';
    import SelectEditor from '../../../Core/ItemEditors/SelectEditor';
    import TextAreaEditor from '../../../Core/ItemEditors/TextAreaEditor.vue';

    import { EventBus } from '../../../../services/event-bus.js';
    export default {
        props: [
            'CareCommunityRecordData'
        ],
        created() {
            let vm = this;
            EventBus.$on('profile-update-needed', chartID => {
                if (chartID == vm.CareCommunityRecordData.Id) {
                    vm.UpdateChartData();
                }
            });

        },
        beforeDestroy() {
            EventBus.$off('profile-update-needed');
        },
        data: function () {
            return {
                EditMode: false,
            }
        },
        methods: {
            UpdateChartData() {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/CareCommunity/CareCommunity", { Id: this.CareCommunityRecordData.Id }, this.UpdateChartDataSuccess, () => { }, true);
            },
            UpdateChartDataSuccess(response) {
                this.$store.commit("CareCommunities.CareCommunityList.UpdateSingleRecord", response.data.data);
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
        },
        components: {
            GoogleMapsLink,
            EditMode,
            StringEditor,
            AddressEditor,
            SelectEditor,
            TextAreaEditor
        },
        mounted() {
        },
        computed: {
            //CurrentTeamMembers: function () {
            //    let output = {
            //        Supervisor: "Unassigned",
            //        BHS: "Unassigned",
            //        Facilitator: "Unassigned",
            //        PP: "Unassigned",
            //        Clinician: "Unassigned"
            //    };
            //    let bhsList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Behavioral Health Specialist");
            //    if (bhsList.length > 0) {
            //        output.BHS = bhsList.map(e => e.Employee.Person.FullName).join(', ');
            //    }
            //    let facilitatorList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Facilitator");
            //    if (facilitatorList.length > 0) {
            //        output.Facilitator = facilitatorList.map(e => e.Employee.Person.FullName).join(', ');
            //    }
            //    let ppList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Parent Partner");
            //    if (ppList.length > 0) {
            //        output.PP = ppList.map(e => e.Employee.Person.FullName).join(', ');
            //    }
            //    let clinicianList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Clinician");
            //    if (clinicianList.length > 0) {
            //        output.Clinician = clinicianList.map(e => e.Employee.Person.FullName).join(', ');
            //    }
            //    let supervisorList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Supervisor");
            //    if (supervisorList.length > 0) {
            //        output.Supervisor = supervisorList.map(e => e.Employee.Person.FullName).join(', ');
            //    }

            //    return output;

            //},
            CurrentFamilies: function () {
                let currents = this.CareCommunityRecordData.FamilyCareCommunityMemberships.filter(r => r.EndDate == null);
                if (currents.length > 0 && currents[0].Family) {
                    return currents;
                } else {
                    return [];
                }
            },
            CurrentFamilyCount: function () {
                return this.CareCommunityRecordData.FamilyCareCommunityMemberships.filter(r => r.EndDate == null).length;
            },
            TrueFalseOptions: function () {
                return this.$store.state.Options.TrueFalseOptions;
            }
        }
    }
</script>

<style scoped>
</style>